import axios from 'axios'

export default {
	setBanks: async ({ commit, state }) => {
		if (_.isEmpty(state.banks)) {
			return await axios.get('/api/banks').then(
				({
					data: {
						data: { banks },
					},
				}) => {
					commit('setBanks', banks)
				}
			)
		}
	},
}
